import { jobOpportunitySelector } from "./selector";
import { useSelector, useDispatch } from "react-redux";
import { updateStartJob, resetJobOpportunityInfo } from "./action";
import DropDown from "../common/SearchableSelect";
import useConfiguration from "../../hooks/useConfiguration";

export default (props) => {
    const { masterData, startJob } = useSelector(jobOpportunitySelector);
    const config = useConfiguration();
    const dispatch = useDispatch();

    const updateJobPostTemplate = (target) => {
        if(target.action === 'remove'){
           // dispatch(resetJobOpportunityInfo());
        } else {
            dispatch(updateStartJob(`${config.baseUrl}`, 'templateID', target.value));
        }
    };

    return (
        <div className="card">
            <div>
                <div className="row">
                    <div className="card-header">
                        <h3 class="card-title">Choose from shift templates*</h3>
                    </div>
                    <div className="card-body">
                        <div class="row">
                        <DropDown name={'jobTemplate'}
                            id={'jobTemplate'}
                            options={masterData?.allTemplates} multiple={false}
                            value={startJob?.templateID ? [startJob?.templateID] : []}
                            updateValue={updateJobPostTemplate} isObject={true}
                            errors={props.errors ? props.errors['startJobTemplate'] : []}
                        />
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}
